export default __webpack_public_path__ + "static/cfofana-8eb931d6ac10a47ced661c0309f3a561.jpg";